<template>
    <div class="container-fluid exit__page">
        <div class="row no-gutters" v-if="quizSuccess[0] == 1 && quizSuccess[1] == 1 && quizSuccess[2] == 1">
            <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3 pt-0 pt-lg-5 pt-xl-0 text-center">
                <h1 class="font-black font-size-56 color--red" v-html="$t('PAGEEND_TEXT01')">Congratulations!</h1>
                <p ><span class="font-weight-bold" v-html="$t('PAGEEND_TEXT02')" v-if="giftInfo == 1 || user.gift_active == 1">You have completed the Tokyo Tour and collected all 3 souvenirs, this entitles you to receive a special gift, your on your way to becoming a J-Beauty Expert.</span></p>
                <p class="font-weight-bold" v-html="$t('PAGEEND_TEXT02_NO_GIFT')" v-if="giftInfo == 0 || user.gift_active == 0">You have completed the Tokyo Tour and collected all 3 souvenirs, well done! You’re on your way to become a J-Beauty Expert.</p>

            </div>
        </div>
        <div class="row no-gutters" v-else>
            <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3 pt-0 pt-lg-5 pt-xl-0 text-center">
                <h1 class="font-black font-size-56 color--red" v-html="$t('PAGEEND_TEXT03')">Thank you!</h1>
                <p ><span class="font-weight-bold" v-html="$t('PAGEEND_TEXT04')">for taking the Tokyo Tour module , you can check out your results below, unfortunately you didn’t manage to pick up all 3 souvenir pins this time</span><span class="font-weight-bold" v-html="$t('QUIZ_RESULT04_EXTRA')" v-if="pinInfo == 1"></span></p>
            </div>
        </div>
        <div class="row no-gutters mt-6">
            <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3 pt-0 pt-lg-5 pt-xl-0">
                <div class="card-deck" v-if="windowWidth > 992">
                    <div class="card">
                        <div class="card-body">
                            <h2 class="text-uppercase font-black" v-html="$t('WORLD01_TEXT01')">Ginza</h2>

                            <div class="badge__landmarks">
                                <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                                <p><span class="badge__status--check" :class="{'checked': progressStatus[0][index-1] == 1}" v-for="(index, item) in landmarksMax[0]"></span></p>
                            </div>
                            <div class="badge__quiz">
                                <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                                <p><span class="badge__status--check" :class="{'checked': quizSuccess[0] >= 1 || quizStatus[0] >= 3}" v-for="item in quizStatusMax[0]"></span></p>
                            </div>

                            <p class="badge__souvenir" ><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img v-if="quizSuccess[0] >= 1" src="@/assets/global/souvenir_ginza.svg" class="img-fluid"></p>
                            <div class="d-flex mt-5 mb-3">
                                <div class="close__module btns" v-on:click="correctAnswers(1)" v-html="$t('GLOBAL_CORRECT')">
                                    correct answers
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h2 class="text-uppercase font-black" v-html="$t('WORLD02_TEXT01')">Ueno Park</h2>
                            <div class="badge__landmarks">
                                <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                                <p><span class="badge__status--check" :class="{'checked': progressStatus[1][index-1] == 1 }" v-for="(index, item) in landmarksMax[1]"></span></p>
                            </div>
                            <div class="badge__quiz">
                                <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                                <p><span class="badge__status--check" :class="{'checked': quizSuccess[1] >= 1 || quizStatus[1] >= 3}" v-for="item in quizStatusMax[1]"></span></p>
                            </div>
                            <p class="badge__souvenir" ><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img v-if="quizSuccess[1] >= 1" src="@/assets/global/souvenir_park.svg" class="img-fluid"></p>
                            <div class="d-flex mt-5 mb-3">
                                <div class="close__module btns" v-on:click="correctAnswers(2)" v-html="$t('GLOBAL_CORRECT')">
                                    correct answers
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h2 class="text-uppercase font-black" v-html="$t('WORLD03_TEXT01')">Asakusa</h2>
                            <div class="badge__landmarks">
                                <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                                <p><span class="badge__status--check" :class="{'checked': progressStatus[2][index-1] == 1 }" v-for="(index, item) in landmarksMax[2]"></span></p>
                            </div>
                            <div class="badge__quiz">
                                <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                                <p><span class="badge__status--check" :class="{'checked': quizSuccess[2] >= 1 || quizStatus[2] >= 3}" v-for="item in quizStatusMax[2]"></span></p>
                            </div>

                            <p class="badge__souvenir" ><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img v-if="quizSuccess[2] >= 1" src="@/assets/global/souvenir_asakusa.svg" class="img-fluid"></p>
                            <div class="d-flex mt-5 mb-3">
                                <div class="close__module btns" v-on:click="correctAnswers(3)" v-html="$t('GLOBAL_CORRECT')">
                                    correct answers
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Slick ref="slick" :options="slickOptions" v-else class="mobile__slider">
                    <div class="card">
                        <div class="card-body">
                            <h2 class="text-uppercase font-black" v-html="$t('WORLD01_TEXT01')">Ginza</h2>

                            <div class="badge__landmarks">
                                <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                                <p><span class="badge__status--check" :class="{'checked': progressStatus[0][index-1] == 1 }" v-for="(index, item) in landmarksMax[0]"></span></p>
                            </div>
                            <div class="badge__quiz">
                                <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                                <p><span class="badge__status--check" :class="{'checked': quizSuccess[0] >= 1 || quizStatus[0] >= 3}" v-for="item in quizStatusMax[0]"></span></p>
                            </div>

                            <p class="badge__souvenir" ><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img v-if="quizSuccess[0] >= 1" src="@/assets/global/souvenir_ginza.svg" class="img-fluid"></p>
                            <div class="d-flex mt-5 mb-3">
                                <div class="close__module btns" v-on:click="correctAnswers(1)" v-html="$t('GLOBAL_CORRECT')">
                                    correct answers
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h2 class="text-uppercase font-black" v-html="$t('WORLD02_TEXT01')">Ueno Park</h2>
                            <div class="badge__landmarks">
                                <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                                <p><span class="badge__status--check" :class="{'checked': progressStatus[1][index-1] == 1 }" v-for="(index, item) in landmarksMax[1]"></span></p>
                            </div>
                            <div class="badge__quiz">
                                <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                                <p><span class="badge__status--check" :class="{'checked': quizSuccess[1] >= 1 || quizStatus[1] >= 3}" v-for="item in quizStatusMax[1]"></span></p>
                            </div>
                            <p class="badge__souvenir"><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img  v-if="quizSuccess[1] >= 1" src="@/assets/global/souvenir_park.svg" class="img-fluid"></p>
                            <div class="d-flex mt-5 mb-3">
                                <div class="close__module btns" v-on:click="correctAnswers(2)" v-html="$t('GLOBAL_CORRECT')">
                                    correct answers
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <h2 class="text-uppercase font-black" v-html="$t('WORLD03_TEXT01')">Asakusa</h2>
                            <div class="badge__landmarks">
                                <p v-html="$t('GLOBAL_HIGHLIGHTS01')">Highlights visited</p>
                                <p><span class="badge__status--check" :class="{'checked': progressStatus[2][index-1] == 1 }" v-for="(index, item) in landmarksMax[2]"></span></p>
                            </div>
                            <div class="badge__quiz">
                                <p v-html="$t('GLOBAL_QUIZ_FINISHED')">Quiz finished</p>
                                <p><span class="badge__status--check" :class="{'checked': quizSuccess[2] >= 1 || quizStatus[2] >= 3}" v-for="item in quizStatusMax[2]"></span></p>
                            </div>

                            <p class="badge__souvenir"><span v-html="$t('GLOBAL_QUIZ_SOUVENIR')">Souvenir collected</span> <img  v-if="quizSuccess[2] >= 1" src="@/assets/global/souvenir_asakusa.svg" class="img-fluid"></p>
                                <div class="d-flex mt-5 mb-3">
                                    <div class="close__module btns" v-on:click="correctAnswers(3)" v-html="$t('GLOBAL_CORRECT')">
                                        correct answers
                                    </div>
                                </div>

                        </div>
                    </div>
                </Slick>

            </div>
        </div>
        <div class="row mt-6" v-if="pinInfo == 1">
            <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3 pt-0 pt-lg-5 pt-xl-0 text-center" v-html="$t('PAGEEND_TEXT05')">
                <p>For those of you who are also a Discover –Shiseido member you have also collected a seasonal pin for completion of this module</p>
            </div>
        </div>
        <div class="row mt-6">
            <div class="col-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3 pt-0 pt-lg-5 pt-xl-0">
                <div class="row">
                    <div class="col" v-if="(quizSuccess[0] >= 1 && quizSuccess[1] >= 1 && quizSuccess[2] >= 1) && user.gift_active != 0 && !(user.user.lang == 'NL' && user.user.is_douglas == 1)">
                        <div class="d-flex mt-5 mb-3">
                            <div class="close__module btns text-center" v-on:click="registerGift" v-html="$t('PAGEEND_TEXT06')">
                                discover your gift
                            </div>
                        </div>
                    </div>
                   <!-- <div class="col">
                        <div class="d-flex mt-5 mb-3">
                            <div class="close__module btns text-center" v-on:click="sendPostcard" v-html="$t('PAGEEND_TEXT07')">
                                send a postcard
                                to a colleague
                            </div>
                        </div>
                    </div> -->
                    <div class="col">
                        <div class="d-flex mt-5 mb-3">
                            <div class="close__module btns text-center" v-on:click="closeModule" v-html="$t('GLOBAL_CLOSE')">
                                close module
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import lrsService from "@/services/lrsService";
    import Question from "@/components/Question";
    import $ from 'jquery'
    import Slick from 'vue-slick';
    export default {
        name: "page-035",
        components:{
            Question,
            Slick,
        },
        props:{
            kapitel: "",
        },
        data: function () {
            return {
                windowWidth: window.innerWidth,
                worldStatus: [1, 0, 0],
                progressStatus: [[0,0],[0,0,0,0],[0,0,0,0]],
                quizStatus: [0, 0, 0],
                quizSuccess: [0, 0, 0],
                user: Object,
                pinInfo: 1,
                giftInfo: 1,
                slickOptions: {
                    slidesToShow: 1,
                    arrows: false,
                    draggable: false,
                    accessibility: false,
                    infinite: false,
                    vertical: false,
                    dots: true,
                    swipe: false,
                    adaptiveHeight: true
                },
            }
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },
        methods: {
            closeModule(){
                let url;
                if(this.user.user.is_member == 1 && this.user.user.is_douglas == 1 || this.user.user.is_loungeuser == 1){
                    url = this.user.exit_url_jbl;

                } else {
                    url = this.user.exit_url;
                }
                window.location = 'https://www.discover-shiseido.com'+url;
            },
            onResize() {
                this.windowWidth = window.innerWidth
            },
            correctAnswers(worldName){
                if(worldName == 1){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '010', showRightAnswers: true }});
                } else if(worldName == 2){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '020', showRightAnswers: true }});
                } else if(worldName == 3){
                    this.$router.push({name: 'pages', params: { kapitel: '02', pageid: '030', showRightAnswers: true }});
                }

            },
            registerGift(){
                let l = this.user.user.language;
                let c = this.user.user.country;
                //window.location = 'https://www.discover-shiseido.com/shiseido-skincare_'+c+'_'+l+'/your-gift-tokyo-tour/';

                if(this.user.user.is_member == 1 && this.user.user.is_douglas == 1 || this.user.user.is_loungeuser == 1){
                    window.location = 'https://www.discover-shiseido.com/j-beauty-lounge_bl_'+l+'/your-gift-tokyo-tour-'+c;

                } else {
                    window.location = 'https://www.discover-shiseido.com/shiseido-skincare_'+c+'_'+l+'/your-gift-tokyo-tour/';
                }
            }
        },
        created() {
            this.$store.watch(
                (state, getters) => getters.moduleStatus,
                (newValue, oldValue) => {
                    let moduleStat = this.$store.getters.moduleStatus;
                    for (let i = 0; i < moduleStat.length; i++) {
                        let key = moduleStat[i];
                        switch (key[0]) {
                            case '01':
                                this.worldStatus[1] = 1;
                                break;
                            case '02':
                                this.worldStatus[2] = 1;
                                break;
                            case '01-01':
                                this.progressStatus[0][0] = 1;
                                break;
                            case '01-02':
                                this.progressStatus[0][1] = 1;
                                break;
                            case '02-01':
                                this.progressStatus[1][0] = 1;
                                break;
                            case '02-02':
                                this.progressStatus[1][1] = 1;
                                break;
                            case '02-03':
                                this.progressStatus[1][2] = 1;
                                break;
                            case '02-04':
                                this.progressStatus[1][3] = 1;
                                break;
                            case '03-01':
                                this.progressStatus[2][0] = 1;
                                break;
                            case '03-02':
                                this.progressStatus[2][1] = 1;
                                break;
                            case '03-03':
                                this.progressStatus[2][2] = 1;
                                break;
                            case '03-04':
                                this.progressStatus[2][3] = 1;
                                break;
                        }
                    }
                }
            ),
                this.$store.watch(
                    (state, getters) => getters.user,
                    (newValue, oldValue) => {
                        let u = this.$store.getters.user;
                        if (typeof u === 'string' || u instanceof String){
                            u = JSON.parse(u)
                        }
                        this.user = u;
                        this.quizSuccess = u.quiz.successful;
                        this.quizStatus = u.quiz.attempts;
                    }
                ),
                this.$store.watch(
                    (state, getters) => getters.seePinInfo,
                    (newValue, oldValue) => {
                        this.pinInfo = this.$store.getters.seePinInfo;
                        console.log("See Pin Info?(watch) :", this.pinInfo)
                    }
                ),
                this.$store.watch(
                    (state, getters) => getters.seeGiftInfo,
                    (newValue, oldValue) => {
                        this.giftInfo = this.$store.getters.seeGiftInfo;
                        console.log("See Pin Info?(watch) :", this.giftInfo)
                    }
                )
        },
        mounted() {
            let moduleStat = this.$store.getters.moduleStatus;
            this.pinInfo = this.$store.getters.seePinInfo;
            this.giftInfo = this.$store.getters.seeGiftInfo;
            for (let i = 0; i < moduleStat.length; i++) {
                let key = moduleStat[i];
                switch (key[0]) {
                    case '01':
                        this.worldStatus[1] = 1;
                        break;
                    case '02':
                        this.worldStatus[2] = 1;
                        break;
                    case '01-01':
                        this.progressStatus[0][0] = 1;
                        break;
                    case '01-02':
                        this.progressStatus[0][1] = 1;
                        break;
                    case '02-01':
                        this.progressStatus[1][0] = 1;
                        break;
                    case '02-02':
                        this.progressStatus[1][1] = 1;
                        break;
                    case '02-03':
                        this.progressStatus[1][2] = 1;
                        break;
                    case '02-04':
                        this.progressStatus[1][3] = 1;
                        break;
                    case '03-01':
                        this.progressStatus[2][0] = 1;
                        break;
                    case '03-02':
                        this.progressStatus[2][1] = 1;
                        break;
                    case '03-03':
                        this.progressStatus[2][2] = 1;
                        break;
                    case '03-04':
                        this.progressStatus[2][3] = 1;
                        break;
                }
            }
            let u = this.$store.getters.user;
            if (typeof u === 'string' || u instanceof String){
                u = JSON.parse(u)
            }
            this.user = u;
            this.quizSuccess = u.quiz.successful;
            this.quizStatus = u.quiz.attempts;
            if(u.pins["TokyoTour-2"] == 0){
                console.log("Send Pin 2");
                lrsService.sendLRS('mastered', 'pin2');
                u.pins["TokyoTour-2"] = 1;
            }
            if(this.quizSuccess[0] == 1 && this.quizSuccess[1] == 1 && this.quizSuccess[2] == 1){

            }
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
            })
        },
        computed: {
            landmarks() {
                return [0, 0, 0]
            },
            quizStatusMax() {
                return [1, 1, 1]
            },
            landmarksMax() {
                return [2, 4, 4]
            }
        }
    }
</script>

<style scoped>
.guide{
    max-width: 150px;
}
</style>